function isNonEmptyString(value) {
  return typeof value === "string" && value.length > 0;
}

export function getExtractorForQuestionType(questionType) {
  return {
    YesNoQuestion: adapters.multipleChoice,
    WarningQuestion: adapters.multipleChoice,
    MedicineRestrictionQuestion: adapters.multipleChoice,
    FreeTextMedicalQuestion: adapters.freeTextMedical,
    CustomFreeTextMedicalQuestion: adapters.customFreeTextMedical,
    MedicalQuestion: adapters.medical,
    BloodPressureQuestion: adapters.bloodPressureRange,
    PreviousMigraineTreatmentQuestion: adapters.previousMigraineTreatment,
    DateQuestion: adapters.date,
    BmiWithComorbiditiesQuestion: adapters.bmiWithComorbidities,
    SingleSelectQuestion: adapters.multipleChoice,
    TermsAndConditionsQuestion: adapters.termsAndConditions,
    AssistedPrescribeOptInQuestion: adapters.termsAndConditions,
  }[questionType];
}

const adapters = {
  freeText(question) {
    return {
      answer: question.response || "",
    };
  },
  simpleBmi(question) {
    return question.response;
  },
  bmiWithComorbidities(question) {
    if (question.ethnicityQuestion) {
      return {
        ...question.response,
        ethnicityResponse: {
          questionType: question.ethnicityQuestion.questionType,
          response: question.ethnicityQuestion.response,
          isChangedAnswer: question.ethnicityQuestion.isChangedAnswer || false,
        },
      };
    }
    return question.response;
  },
  weight(question) {
    return question.response;
  },
  multipleChoice(question) {
    if (question.response === null) {
      return null;
    }

    return {
      response: question.response,
      isChangedAnswer: question.isChangedAnswer || false,
      ...(question.freeTextResponse && {
        freeTextResponse: question.freeTextResponse,
      }),
    };
  },
  multiSelect(question) {
    if (question.response === null) {
      return null;
    }

    return {
      response: question.response,
      isChangedAnswer: question.isChangedAnswer || false,
      freeTextResponse: question.freeTextResponse,
    };
  },
  medical(question) {
    if (
      question.isTakingAnyMedicine === null ||
      (question.isTakingAnyMedicine && question.isTakingContraindicated === null)
    ) {
      return null;
    }

    return {
      takingAny: question.isTakingAnyMedicine,
      takingContraindicated: question.isTakingContraindicated,
      isChangedAnswer: question.isChangedAnswer || false,
    };
  },
  freeTextMedical(question) {
    if (
      question.isTakingAnyMedicine === null ||
      (question.isTakingAnyMedicine && question.isTakingContraindicated === null)
    ) {
      return null;
    }

    return {
      takingAny: question.isTakingAnyMedicine,
      takingContraindicated: question.isTakingContraindicated,
      otherMedicinesTaken: question.otherMedicinesTaken,
    };
  },
  customFreeTextMedical(question) {
    if (question.isResponseYes === null) {
      return null;
    }

    return {
      responseYes: question.isResponseYes,
      freeTextResponse: question.freeTextResponse,
    };
  },
  bloodPressureRange(question) {
    if (
      question.recentReading !== true ||
      !isNonEmptyString(question.systolicRange) ||
      !isNonEmptyString(question.diastolicRange)
    ) {
      return null;
    }

    return {
      recentReading: question.recentReading,
      diastolicRange: question.diastolicRange,
      systolicRange: question.systolicRange,
      isRange: true,
    };
  },
  bmi(component) {
    return {
      heightOption: component.heightOption.id,
      heightMajor: component.heightMajor,
      heightMinor: component.heightOption.showMinor ? component.heightMinor : null,
      weightOption: component.weightOption.id,
      weightMajor: component.weight,
      weightMinor: component.weightOption.showMinor ? component.weightMinor : null,
      highRisk: component.highRisk,
    };
  },
  previousMigraineTreatment(question) {
    if (
      question.hasTriedTriptans === null ||
      (question.hasTriedTriptans === true &&
        (question.hasExperiencedRelief === null || question.hasExperiencedSideEffects === null))
    ) {
      return null;
    }

    return {
      hasTriedTriptans: question.hasTriedTriptans,
      hasExperiencedRelief: question.hasExperiencedRelief,
      hasExperiencedSideEffects: question.hasExperiencedSideEffects,
    };
  },
  date(question) {
    if (question.response === null) return null;

    return {
      response: question.response,
      isChangedAnswer: question.isChangedAnswer || false,
    };
  },
  photoUpload(question) {
    if (question.responseImageKey === null) {
      return null;
    }

    return {
      responseImageKey: question.responseImageKey,
      isChangedAnswer: question.isChangedAnswer || false,
    };
  },
  termsAndConditions(question) {
    if (question.response === null) {
      return null;
    }

    return {
      response: question.response,
      isChangedAnswer: question.isChangedAnswer || false,
    };
  },
};
export default adapters;
